// extracted by mini-css-extract-plugin
module.exports = {"bigImage":"BigImage-module--big-image--aQM7O","imgbtn":"BigImage-module--imgbtn--37Hcf"};